import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchOrderTickets = createAsyncThunk("fetchOrderTickets", async ({ orderId }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`orders/${orderId}/ticket`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});
const TicketsSlice = createSlice({
	name: "TicketsSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchOrderTickets.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchOrderTickets.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchOrderTickets.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});
export default TicketsSlice.reducer;
